import React from 'react';
import Popover from 'material-ui/Popover';
import FlatButton from 'material-ui/FlatButton';
import Chip from 'material-ui/Chip';
import { Footer, DropDownUserName, DropDownEmail } from './styles';
import { Redirect } from 'react-router-dom';
import config from '../../../config/config'
import { displayRole } from '../../../lib/lib'

const ProfileDropDown = ({
  direct,
  logoutSuccess,
  open,
  anchorEl,
  anchorOrigin,
  targetOrigin,
  onRequestClose,
  email,
  accountType,
  name,
  logoutUser,
  recieveLoginstatus,
  shouldRedirectUser,
  user_id,
  role,
  location
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      targetOrigin={targetOrigin}
      onRequestClose={onRequestClose}
      zDepth={4}
      className='popover'
      style={{overflowY: 'none', border: 3}}
    >
      <div className='pa3 flex'>
        <div>
          <img src={ direct ? "https://" + config.API_HOST + "/api/v1/image/" +  name : "https://" + config.API_HOST + "/api/v1/image/" +  user_id } alt='profile' />
        </div>
        <div className='pl3 flex justify-around flex-column'>
          <DropDownUserName>
            {name}
          </DropDownUserName>
          <DropDownEmail>
            {email}
          </DropDownEmail>
          <div>
            <Chip backgroundColor='#4688F1'>
              <div className='white ttu'>
                {displayRole(location, role)}
              </div>
            </Chip>
          </div>
        </div>
      </div>
    </Popover>
  );
};

export default ProfileDropDown;



// WEBPACK FOOTER //
// ./src/components/Profile/NavBarProfile/ProfileDropDown.js